import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { Dictionary } from "../store/models/common_types";

@Injectable({
  providedIn: "root",
})
export class RevisionPageDataService {
  apiEP: string = window.apiUrl;

  constructor(private http: HttpClient) {}

  getRevisionsMata(ticker: string, tickertype: string): Observable<any> {
    return this.http.get(
      `${this.apiEP}/api/get_revision_dashboard_meta/?ticker=${ticker}&tickertype=${tickertype}`,
    );
  }

  getLineitemsData(pg: string, cut: string, ticker: string): Observable<any> {
    return this.http.get(
      `${this.apiEP}/api/get_revision_dashboard_lineitems/?version=1&pg=${pg}&cut=${cut}&ticker=${ticker}`,
    );
  }

  getPgData(
    period: string,
    pg: string,
    cut: string,
    ticker: string,
    source: string,
    growthType: string,
    crdrevision: string,
    revision: string,
  ): Observable<any> {
    let url = `${this.apiEP}/api/pg?period=${period}&pg=${pg}&cut=${cut}&ticker=${ticker}&source=${source}&revision=Current&revision=${revision}&basis=All&depth=default`;
    // using growthType=Analytics for yoy, replace with ${growthType} once Revision
    // Analysis Page starts using yoy from pg call.
    url =
      url +
      (growthType === "yoy"
        ? "&growthType=yoy%25"
        : `&crdrevision=${crdrevision}&crd=true&growthType=${growthType}`);
    return this.http.get(url);
  }

  getParamData(params: Dictionary<any>): Observable<any> {
    let url = `${this.apiEP}/api/param3?&param=${params.paramId}&period=${params.period}&ticker=${params.ticker}&pg=${params.pg}&cut=${params.cut}&revision=Current&revision=${params.revision}&basis=All&depth=default&is_revision_page=true`;
    url =
      url +
      (params.growthType === "yoy"
        ? "&growthType=yoy%25"
        : `&crdrevision=${params.revision}&crd=true&growthType=${params.growthType}`);
    for (let i = 0; i < params.sources.length; i++) {
      url += `&source=${params.sources[i]}`;
    }
    return this.http.get(url);
  }

  saveUserFilters = (
    jsonData: Record<string, any>,
    company: string,
  ): Observable<any> => {
    return this.http.post(
      `${this.apiEP}/api/revision_dashboard_history/?ticker=${company}`,
      { company, jsonData, source: null, cut: null },
    );
  };
}
